import { AxiosProgressEvent } from "axios"

import http from "../../../../global/http"

export const uploadPhotographFiles = (
  orgId: string,
  patientId: string,
  caseId: string,
  fileName: string,
  formData: FormData,
  callback: (progress: AxiosProgressEvent) => void,
) => {
  const url = `/patient-mgmt/v2/org/${orgId}/patients/${patientId}/txplans/${caseId}/photographs/${fileName}`
  try {
    const res = http.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: callback,
    })
    return res
  } catch (err) {
    return err
  }
}

export const downloadPhotographFiles = (
  orgId: string,
  patientId: string | undefined,
  caseId: string | undefined,
  fileName: string,
) => {
  const url = `/patient-mgmt/v2/org/${orgId}/patients/${patientId}/txplans/${caseId}/photographs/${fileName}`
  try {
    const res = http.get(url, {
      responseType: "blob",
    })
    return res
  } catch (err) {
    return err
  }
}

export const fetchFileList = (
  orgId: string,
  patientId: string | undefined,
  caseId: string | undefined,
) => {
  const url = `/patient-mgmt/v1/org/${orgId}/patients/${patientId}/txplans/${caseId}/files`
  try {
    const res = http.get(url)
    return res
  } catch (err) {
    return err
  }
}
